var map = {
	"./sound/correct.mp3": 4118,
	"./sound/deviceSound/banshou.mp3": 1073,
	"./sound/deviceSound/broadcastEmergencyInfoPlay.mp3": 7097,
	"./sound/deviceSound/buttonPress.mp3": 1089,
	"./sound/deviceSound/buttonRun.mp3": 4894,
	"./sound/deviceSound/closeFanWindow.mp3": 4674,
	"./sound/deviceSound/deviceRun.mp3": 2158,
	"./sound/deviceSound/fanDeviceRun.mp3": 6122,
	"./sound/deviceSound/fireAlarm.mp3": 1256,
	"./sound/deviceSound/key.mp3": 4300,
	"./sound/deviceSound/phoneRing.mp3": 8312,
	"./sound/deviceSound/phoneWaiting.mp3": 277,
	"./sound/deviceSound/superviseAlarm.mp3": 6612,
	"./sound/deviceSound/troubleAlarm.mp3": 8816,
	"./sound/error.mp3": 6322,
	"./sound/operation.mp3": 8680,
	"./sound/oral.mp3": 7445,
	"./sound/recognize.mp3": 4749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1025;